import { FoodsTooltip } from "@foodpilot/foods";
import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { formatExactImpact, getImpactDisplay } from "src/context/Scores/utils/impactDisplay";

type Props = {
    value: number | null | undefined;
    precision: number;
    unit: string;
    sx?: SxProps<Theme>;
    children: ReactNode;
};

export const ApproximateImpactTooltip = (props: Props) => {
    const { value, precision, unit, sx, children } = props;
    const { t, i18n } = useTranslation();

    if (value === null || value === undefined || getImpactDisplay(value, precision).isApproximate === false) {
        return children;
    }

    return (
        <FoodsTooltip
            describeChild
            title={t("action_plan.impact.exact_value", "Exact value: {{value}} {{unit}}", {
                value: formatExactImpact(value, i18n.language),
                unit,
            })}
        >
            <Box
                component="span"
                tabIndex={0}
                sx={[{ display: "inline-flex", alignItems: "center" }, ...(Array.isArray(sx) ? sx : [sx])]}
            >
                {children}
            </Box>
        </FoodsTooltip>
    );
};
